const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 362 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Weird-Shape",
    d: "M61.581,219.84c-40.695,-31.396 -0.516,-155.885 68.6,-179.926c69.115,-24.041 189.727,53.6 179.698,93.503c-10.029,39.904 -99.016,17.539 -129.285,27.425c-30.268,9.885 -78.317,90.395 -119.013,58.998Z",
    style: {
      fill: "#a9e8f6",
      fillOpacity: 0.47
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Weird-Shape1",
    serifId: "Weird-Shape",
    d: "M231.424,69.649c-0.465,16.558 15.161,35.162 35.725,35.592c20.564,0.43 37.215,-17.498 37.68,-34.056c0.465,-16.558 -22.896,-23.208 -39.762,-23.561c-16.867,-0.352 -33.178,5.467 -33.643,22.025Z",
    style: {
      fill: "#f6cacb",
      fillOpacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.617,
    y: 69.689,
    width: 87.168,
    height: 160.879,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.89,
    y: 122.236,
    width: 74.129,
    height: 116.469,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.682,248.119l-246.567,0l0,-195.004l105.002,0l0,195.004l13.594,0l0,-162.66l87.659,32.814l0,129.846l40.312,0Zm-113.44,-21.563l58.595,0l0,-17.344l-58.595,0l0,17.344Zm0,-26.719l58.595,0l0,-17.813l-58.595,0l0,17.813Zm0,-27.188l58.595,0l0,-17.813l-58.595,0l0,17.813Zm0,-27.188l58.595,0l0,-17.813l-58.595,0l0,17.813Zm-115.314,-41.251l26.719,0l0,-29.063l-26.719,0l0,29.063Zm42.657,120.94l26.719,0l0,-28.595l-26.719,0l0,28.595Zm0,-40.314l26.719,0l0,-28.594l-26.719,0l0,28.594Zm0,-40.313l26.719,0l0,-28.594l-26.719,0l0,28.594Zm-42.657,80.627l26.719,0l0,-28.595l-26.719,0l0,28.595Zm0,-40.314l26.719,0l0,-28.594l-26.719,0l0,28.594Zm0,-40.313l26.719,0l0,-28.594l-26.719,0l0,28.594Zm42.657,-40.313l26.719,0l0,-29.063l-26.719,0l0,29.063Z",
    style: {
      fill: "#b3b3b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.cdef0d6d5bdaa0bafe1160a66f99fb78.svg";
export { ForwardRef as ReactComponent };